import axios, { AxiosError } from "axios";
import { adapterMockSobDemanda, mockApiAtivo } from "./mockApiFlag";
import { limparCacheGet } from "./cacheGet";

const BASE_URL = "/api/v1";

export const TEMPO_LIMITE_MS = 3600000;

const API_TOKEN = "apiToken";
const API_TOKEN_EXPIRA = "apiTokenExpiraEm";

const MARGEM_EXPIRACAO_MS = 30000;

const instante = (expiraEm?: string | number) => {
  if (typeof expiraEm === "number") {
    return expiraEm;
  }
  if (!expiraEm) {
    return NaN;
  }
  return /^[0-9]+$/.test(expiraEm) ? Number(expiraEm) : Date.parse(expiraEm);
};

export const saveApiToken = (token: string, expiraEm?: string | number) => {
  localStorage.setItem(API_TOKEN, token);
  const validade = instante(expiraEm);
  if (isNaN(validade)) {
    localStorage.removeItem(API_TOKEN_EXPIRA);
  } else {
    localStorage.setItem(API_TOKEN_EXPIRA, String(validade));
  }
};

export const clearApiToken = () => {
  localStorage.removeItem(API_TOKEN);
  localStorage.removeItem(API_TOKEN_EXPIRA);
  limparCacheGet();
};

export const getApiToken = () => {
  const validade = Number(localStorage.getItem(API_TOKEN_EXPIRA));
  if (validade && Date.now() + MARGEM_EXPIRACAO_MS >= validade) {
    clearApiToken();
    return null;
  }
  return localStorage.getItem(API_TOKEN);
};

const apiClient = axios.create({ baseURL: BASE_URL, timeout: TEMPO_LIMITE_MS });

if (mockApiAtivo) {
  apiClient.defaults.adapter = adapterMockSobDemanda();
}

apiClient.interceptors.request.use((config) => {
  const token = getApiToken();
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      clearApiToken();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
        return new Promise(() => {});
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
